export const upConfigRouteToNavbar = (config) => {

    const rest = config;
    config.prop.upConfig(rest);
}